import { schema, Schema } from './request-reset-password-form.schema';
import { zodResolver } from '@hookform/resolvers/zod';
import { Button } from '~/components/Button/Button';
import { Input } from '~/components/Input';
import { useForm } from 'react-hook-form';

interface Props {
  onSubmit: (payload: Schema) => Promise<void>;
  isLoading: boolean;
}

export function RequestResetPasswordForm({ onSubmit, isLoading }: Props) {
  const { formState, register, handleSubmit } = useForm<Schema>({
    resolver: zodResolver(schema),
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Input.Group htmlFor="email" label="E-post" formState={formState}>
        <Input.Field type="email" formState={formState} {...register('email')} />
      </Input.Group>

      <Button.Group>
        <Button type="submit" isLoading={isLoading}>
          Återställ lösenord
        </Button>
      </Button.Group>
    </form>
  );
}
